import { GzHelpAndSupportWebComponent } from './component/GzHelpAndSupportWebComponent';
import { GzHelpAndSupportTabs } from './component/GzHelpAndSupportTabs';

export { GzHelpAndSupportWebComponent, GzHelpAndSupportTabs };
